import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation';
import env from '@tencent/vft-common/env';
import Index from './components/Index.vue';
export default {
  components: {
    ScreenOrientation: ScreenOrientation,
    Index: Index
  },
  computed: {
    isPad: function isPad() {
      return env.isIpad || env.isApad;
    }
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$report.ready();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};